import { render, staticRenderFns } from "./TimetablePage.vue?vue&type=template&id=2d0a0aa3&scoped=true"
import script from "./TimetablePage.vue?vue&type=script&lang=js"
export * from "./TimetablePage.vue?vue&type=script&lang=js"
import style0 from "./TimetablePage.vue?vue&type=style&index=0&id=2d0a0aa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a0aa3",
  null
  
)

export default component.exports